import { ConverterIF } from '@/components/Input/Converter/ConverterIF'
import '@/util/Extension/StringExtensions'

/**
* 制御文字を除外するinputクラス
*/
export default class StringConverter implements ConverterIF {
    /**
     * @brief	input要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertInputValue(target: HTMLInputElement): string {
        if (undefined == target || null == target) {
            return "";
        }

        if ("" === target.value) {
            return "";
        }

        // 制御コードを取り除く
        return target.value.removeControlCode();
    }

    /**
     * @brief	TextArea要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertTextAreaValue(target: HTMLTextAreaElement): string {
        if (undefined == target || null == target) {
            return "";
        }

        if ("" === target.value) {
            return "";
        }

        // 制御コードを取り除く(TextAreaのため改行コードは取り除かない)
        return target.value.removeControlCodeAllowNewLine();
    }
}